module.exports = __webpack_public_path__ + "static/media/cross.c883b6cb.svg";